import { ExperimentsPolicy } from '@playq/octopus2-analytics';
import { GenericFailure } from '@playq/services-shared';

import { useEitherQuery, IUseQueryOptionsExtended } from '/api/service-hooks';

import { appExperimentsService } from './constants';

export const experimentsPolicyKeys: unknown[] = ['experiments', 'policy'];

const emptyArray: [] = [];

export const useExperimentsPolicy = (
  options?: IUseQueryOptionsExtended<ExperimentsPolicy | undefined, GenericFailure | Error>
) => {
  const res = useEitherQuery(experimentsPolicyKeys, () => appExperimentsService.policy(), options);

  return { ...res, options: res.data?.classes || emptyArray };
};
